const middleware = {}

middleware['tfa'] = require('../middleware/tfa.js')
middleware['tfa'] = middleware['tfa'].default || middleware['tfa']

export default middleware
